/* ==========================================================================
  main.js
========================================================================== */

/**
 * Primary menu
 */
var primary_menu = component_primary_menu({
  desktop_min_width: 1000,
  menu: '.primary-navigation',
  upper_menu_mobile: '.upper-navigation-mobile',
  menu_toggle: '#menu-toggle'
});
/**
 * Upper menu
 */
var upper_menu = component_primary_menu({
  desktop_min_width: 1000,
  menu: '.upper-navigation',
  upper_menu_mobile: '.upper-navigation-mobile-2',
  menu_toggle: '#menu-toggle-2'
});
/**
 * Upper menu for mobile
 */
var other_upper_menu = component_primary_menu({
  desktop_min_width: 1000,
  menu: '.upper-navigation-mobile__items',
  upper_menu_mobile: '.upper-navigation-mobile-3',
  menu_toggle: '#menu-toggle-3'
});

/**
 * Responsive videos
 */
fitvids();

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function (e) {
    objectFitPolyfill();
    e.target.addEventListener('load', function () {
      objectFitPolyfill();
    });
  });
}

/**
 * Lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
  // init Tobi
  try {
    const tobi = new Tobii({
      // variables from script localization in register-assets.php
      navLabel: [aucor_starter_strings.prev, aucor_starter_strings.next],
      closeLabel: aucor_starter_strings.close,
      loadingIndicatorLabel: aucor_starter_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}

/**
 * Add .last-class for last writer
 */

// footer
var footerWriters = document.querySelectorAll('.entry__footer .writer');
if (footerWriters.length !== 0) {
  footerWriters.item(footerWriters.length - 1).classList.add('last');
}

// block
var blockWriters = document.querySelectorAll('.block-partners .writer');
if (blockWriters.length !== 0) {
  blockWriters.item(blockWriters.length - 1).classList.add('block-last');
}


/**
 * IE11 detection
 */
var ua = window.navigator.userAgent;
var trident = ua.indexOf('Trident/');
if (trident > 0) {
  document.body.classList.add('IE11');
}
